/**
 * Market-rate intel client (DEV-3636, Interfirst.Skynet.Pricing behind the
 * pricing gateway — the same direct base as channelApi / programApi).
 *
 * - GET /api/pmms/recent: public Freddie Mac PMMS benchmark (not company-scoped).
 * - GET /api/rate-sheets/latest: latest posted rate sheet (company from JWT).
 * - GET /api/lock-extensions/options: display-only posted extension prices.
 *
 * Compliance: rate observations are not a quote or commitment.
 */
export class MarketRatesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRecentPmms({ weeks, config = {} } = {}) {
    return this.#http.get('/api/pmms/recent', { ...config, params: { weeks } });
  }

  async getLatestRateSheet({ channelId, config = {} } = {}) {
    return this.#http.get('/api/rate-sheets/latest', { ...config, params: { channelId } });
  }

  async getLockExtensionOptions({ channelId, loanType, config = {} } = {}) {
    return this.#http.get('/api/lock-extensions/options', {
      ...config,
      params: { channelId, loanType },
    });
  }
}
